import { render, staticRenderFns } from "./DataSingleStandard.vue?vue&type=template&id=66a8aac0&"
import script from "./DataSingleStandard.vue?vue&type=script&lang=js&"
export * from "./DataSingleStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports